import { endpoints } from 'constants/endpoints';

import { sendRequest } from './sendRequest';

export const getCompetencySettingsApi = () => {
  const url = endpoints.competency.competencySetting;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const setCompetencySettingsApi = ({ viewType }) => {
  const url = endpoints.competency.competencySetting;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: { viewType },
  });
};

export const getFunctionListApi = () => {
  const url = endpoints.competency.competencyFunctionList;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getCompetencySummaryApi = ({ functionId }) => {
  const url = endpoints.competency.competencySummary;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      function_id: functionId,
    },
  });
};

export const getCompetencyDescriptionApi = ({ functionId, competencyId }) => {
  const url = endpoints.competency.competencyDescription;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      function_id: functionId,
      competency_id: competencyId,
    },
  });
};

export const updateCompetencyDescriptionApi = ({ description, competencyId, functionId }) => {
  const url = endpoints.competency.updateCompetencyDescription(competencyId);
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: {
      ...description,
    },
  });
};

export const saveCompetencyApi = ({ orgTag, jobFunctionRole = null }) => {
  const url = endpoints.competency.saveCompetency;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      organizationTag: orgTag,
      jobFunctionRole,
    },
  });
};

export const disableCompetencyRowApi = ({ functionId, competencyId }) => {
  const url = endpoints.competency.disableCompetency;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      competency_id: competencyId,
      function_id: functionId,
    },
  });
};

export const enableCompetencyRowApi = ({ functionId, competencyId }) => {
  const url = endpoints.competency.enableCompetency;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      competency_id: competencyId,
      function_id: functionId,
    },
  });
};
